import { render, staticRenderFns } from "./CardRoomSettings.vue?vue&type=template&id=13d25206&scoped=true"
import script from "./CardRoomSettings.vue?vue&type=script&lang=js"
export * from "./CardRoomSettings.vue?vue&type=script&lang=js"
import style0 from "./CardRoomSettings.vue?vue&type=style&index=0&id=13d25206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d25206",
  null
  
)

export default component.exports